import React from 'react';
import SessionLayout from '../layouts/Session/Session';
import ForgotPassword from '../components/Session/ForgotPassword';
import {setPageTitle} from '../utils/helpers';

const ForgotPasswordPageContainer = () => {
  setPageTitle('Forgot Password | Access your UK savings accounts');

  return (
    <SessionLayout>
      <ForgotPassword />
    </SessionLayout>
  );

};

export default ForgotPasswordPageContainer;
